module.exports = __webpack_public_path__ + "img/tianqin4.420e58c1.png";